"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadOwners = exports.FetchOwners = exports.FetchOwnersActionTypes = exports.OwnersActionTypes = void 0;

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var _identity = _interopRequireDefault(require("transmute/identity"));

var OwnersActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_OWNERS: null,
  LOAD_OWNERS: null
}, 'shared');
exports.OwnersActionTypes = OwnersActionTypes;
var FetchOwnersActionTypes = (0, _actions.createRequestTypes)(OwnersActionTypes.FETCH_OWNERS);
exports.FetchOwnersActionTypes = FetchOwnersActionTypes;
var FetchOwners = (0, _actions.createRequestActions)(FetchOwnersActionTypes);
exports.FetchOwners = FetchOwners;
var loadOwners = (0, _fluxActions.createAction)(OwnersActionTypes.LOAD_OWNERS, _identity.default);
exports.loadOwners = loadOwners;